// import React from 'react';
// import Sidebar from '../Sidebar';
// import { useSelector } from 'react-redux';

// const Layout = ({ children }) => {
//   const { toggleSidebar } = useSelector((state) => state.global)
//   return (
//     <div className="app-container d-flex" style={{ height: '100vh' }}>
//       {toggleSidebar && <Sidebar />}
//       <div className={`content flex-grow-1 p-3`}>{children}</div>
//     </div>
//   );
// };

// export default Layout;

import React, { useState, useEffect, useCallback } from 'react';
import Sidebar from '../Sidebar';
import { ChevronDoubleLeft, ChevronDoubleRight, LayoutSidebar, List} from 'react-bootstrap-icons';
import { PanelLeft, SidebarIcon, Menu, X } from 'lucide-react';

const Layout = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(() => {
    const saved = localStorage.getItem('sidebarOpen');
    return saved !== null ? JSON.parse(saved) : true;
  });
  const [sidebarWidth, setSidebarWidth] = useState(() => {
    const saved = localStorage.getItem('sidebarWidth');
    return saved ? parseInt(saved, 10) : 240;
  });
  const [isMobile, setIsMobile] = useState(false);

  const handleToggleSidebar = () => {
    const newState = !isSidebarOpen;
    setIsSidebarOpen(newState);
    localStorage.setItem('sidebarOpen', JSON.stringify(newState));
  };

  const handleSidebarWidthChange = useCallback((width) => {
    setSidebarWidth(width);
    localStorage.setItem('sidebarWidth', String(width));
  }, []);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      
      // On mobile, always start with sidebar closed
      if (mobile && isSidebarOpen) {
        setIsSidebarOpen(false);
        localStorage.setItem('sidebarOpen', 'false');
      }
    };
    
    handleResize(); // Initial check
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [isSidebarOpen]);

  return (
    <div className="app-container d-flex" style={{ height: '100vh', position: 'fixed' }}>

      {/* Mobile Overlay */}
      {isMobile && isSidebarOpen && (
        <div 
          className="mobile-overlay"
          onClick={handleToggleSidebar}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 998,
          }}
        />
      )}

      {/* Sidebar */}
      {isMobile ? (
        <div
          className="custom-sidebar mobile-sidebar"
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            height: '100%',
            width: '280px',
            transform: isSidebarOpen ? 'translateX(0)' : 'translateX(-100%)',
            transition: 'transform 0.3s ease',
            zIndex: 999,
            boxShadow: isSidebarOpen ? '2px 0 10px rgba(0, 0, 0, 0.1)' : 'none',
          }}
        >
          <Sidebar />
        </div>
      ) : (
        <div
          className={`custom-sidebar desktop-sidebar ${!isSidebarOpen ? 'collapsed' : ''}`}
          style={{
            width: `${sidebarWidth}px`,
            transform: isSidebarOpen ? 'translateX(0)' : 'translateX(-100%)',
            transition: 'transform 0.3s ease',
          }}
        >
          <Sidebar
            isCollapsed={!isSidebarOpen}
            onToggle={handleToggleSidebar}
            sidebarWidth={sidebarWidth}
            onSidebarWidthChange={handleSidebarWidthChange}
          />
        </div>
      )}

      {!isMobile && !isSidebarOpen && (
        <button
          type="button"
          className="sidebar-expand-btn"
          onClick={handleToggleSidebar}
          aria-label="Expand sidebar"
        >
          <svg width="16" height="16" viewBox="0 0 24 24"
            fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="9 18 15 12 9 6"/>
          </svg>
        </button>
      )}


      {/* Mobile Toggle Button */}
      {isMobile && (
        <button
          onClick={handleToggleSidebar}
          className="mobile-toggle-btn"
          style={{
            position: 'fixed',
            top: '20px',
            left: '20px',
            zIndex: 1000,
            background: 'var(--send-btn-bg)',
            color: 'var(--send-btn-text)',
            border: 'none',
            borderRadius: '50%',
            width: '44px',
            height: '44px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
          }}
        >
          {isSidebarOpen ? <X size={20} /> : <Menu size={20} />}
        </button>
      )}

      <div 
        className="content flex-grow-1"
        style={{
          marginLeft: isSidebarOpen && !isMobile ? `${sidebarWidth}px` : '0',
          transition: 'margin-left 0.3s ease',
          width: isSidebarOpen && !isMobile ? `calc(100vw - ${sidebarWidth}px)` : '100vw',
          height: '100vh',
          overflow: 'hidden'
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default Layout;
